import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the InvestRateHistoryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-invest-rate-history',
  templateUrl: 'invest-rate-history.html',
})
export class InvestRateHistoryPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad InvestRateHistoryPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/invest-rate-history/invest-rate-history.ts